<div class="container">
  <p class="error-404">404</p>

  <p class="error-headline">Ups! Seite nicht gefunden...</p>

  <p class="error-text">
    Die Seite, nach welcher Du suchst, konnte nicht gefunden werden, wurde
    gelöscht oder ist zur Zeit nicht verfügbar.
  </p>

  <button class="back-button" (click)="handleBackButtonClick()">
    <app-icon iconName="redo" iconColor="#fff" iconSize="2.8rem"></app-icon>
    <p>zurück</p>
  </button>
</div>
